import React, {useState} from 'react';
import {useStateContext} from "../../../contexts/ContextProvider";
import {useDispatch, useSelector} from "react-redux";
import instance from "../../../API";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import {getContractDetail} from "../../../redux/slices/contracts/contractsSlice";
import {Loader} from "../../../components";

const CreateAdditionalEmail = () => {
	const dispatch = useDispatch()
	const {id, slug} = useParams();
	const {currentColor} = useStateContext();
	
	const {contractDetail} = useSelector(state => state.contracts);
	
	const [contract_date, setContractDate] = useState(null)
	const [step, setStep] = useState(0)
	
	const [html, setHtml] = useState(null)
	
	const [loading, setLoading] = useState(false)
	
	const createAdditionalContract = async () => {
		setLoading(true)
		try {
			await instance.post("/e-xat/additional/contract-create", {
				parent: contractDetail?.contract?.id,
				contract_date: new Date(contract_date)?.toISOString(),
				save: step
			}).then((res) => {
				if (typeof res?.data === "string") {
					if (!step) {
						setHtml(res?.data)
					}
					setLoading(false)
					setStep(1)
				} else if (res?.data?.success) {
					dispatch(getContractDetail({id, slug}))
					toast.success("Qo'shimcha shartnoma muvofaqqiyatli yaratildi!")
					setStep(0)
					setHtml(null)
					setContractDate(null)
					setLoading(false)
				}
			})
		} catch (e) {
			setLoading(false)
			return e;
		}
	}
	
	const renderAdditional = () => {
		switch (step) {
			case 0:
				return (
					<>
						<div className={'flex flex-col'}>
							<label className="block text-gray-700 text-sm font-bold mb-1 ml-3" htmlFor="tariff">Shartnoma
								sanasi</label>
							<input
								value={contract_date || ""}
								onChange={(e) => setContractDate(e.target.value)}
								name="amount"
								id="amount"
								type="date"
								className="rounded w-full py-1.5 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow focus:border-blue-500 border mb-1"
							/>
						</div>
						<div className="w-full flex items-center justify-between mt-4">
							<div>
								<button
									className={'px-4 py-2 rounded'}
									style={{
										color: currentColor,
										border: `1px solid ${currentColor}`
									}}
									onClick={() => setContractDate(null)}
								>
									Bekor qilish
								</button>
							</div>
							<div className="flex gap-4">
								<button
									className={`px-4 py-2 rounded text-white disabled:opacity-25`}
									style={{backgroundColor: currentColor}}
									disabled={!contract_date}
									onClick={createAdditionalContract}
								>
									Saqlash
								</button>
							</div>
						</div>
					</>
				)
			case 1:
				return (
					<>
						<div
							dangerouslySetInnerHTML={{__html: html || ""}}
							className="px-2 py-3 border rounded"
						/>
						
						<div className="w-full flex items-center justify-between mt-4">
							<div>
								<button
									className={'px-4 py-2 rounded'}
									style={{
										color: currentColor,
										border: `1px solid ${currentColor}`
									}}
									onClick={() => {
										setStep(0)
										setHtml(null)
										setContractDate(null)
									}}
								>
									Bekor qilish
								</button>
							</div>
							<div className="flex gap-4">
								<button
									className={`px-4 py-2 rounded text-white disabled:opacity-25`}
									style={{backgroundColor: currentColor}}
									disabled={!contract_date}
									onClick={createAdditionalContract}
								>
									Saqlash
								</button>
							</div>
						</div>
					</>
				)
			default:
				return <h1 className="text-center text-black">Xatolik</h1>
		}
	}
	
	if (loading) return <Loader />
	
	return (
		<>
			{renderAdditional()}
		</>
	);
};

export default CreateAdditionalEmail;